import { MimeTypes } from '@lokalise/louis';

export const DROPZONE_FILE_MAX_SIZE_MB = 5;

const MEGA_BYTE = 1024 ** 2; // 1024 * 1024 = 1024^2 Bytes = 1MB
export const DROPZONE_FILE_MAX_SIZE_BYTES = DROPZONE_FILE_MAX_SIZE_MB * MEGA_BYTE;

export const DROPZONE_ACCEPTED_FILE_TYPES = [MimeTypes.docx, MimeTypes.pdf];
